import { camelCase, isArray, isObject } from 'lodash';

export function camelCaseObjectKeys<T>(obj: T): T {
  if (!isObject(obj)) return obj;

  const mappableObject = isArray(obj) ? { ...obj } : obj;

  return Object.keys(mappableObject).reduce((result, key) => {
    const camelCaseKey = camelCase(key);

    if (isArray(mappableObject[key as keyof T])) {
      result[camelCaseKey as keyof T] = (mappableObject[key as keyof T] as unknown as T[]).map((value) =>
        camelCaseObjectKeys(value),
      ) as unknown as T[keyof T];
      return result;
    }

    if (isObject(mappableObject[key as keyof T])) {
      result[camelCaseKey as keyof T] = camelCaseObjectKeys(mappableObject[key as keyof T]);
      return result;
    }

    result[camelCaseKey as keyof T] = mappableObject[key as keyof T];
    return result;
  }, {} as T);
}
